const getValidJrsdNmbr = (jrsdNmbr) => {
    if (Number.isInteger(jrsdNmbr) && jrsdNmbr % 2 === 0) {
      jrsdNmbr = jrsdNmbr + 1;
    }
    return jrsdNmbr;
}

export { getValidJrsdNmbr }